import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon, CalculatorIcon, CreditCardIcon, FileDownIcon, SearchIcon } from "lucide-react";
import { routes } from "../../data/business";
import { bondTools } from "../../data/home";
import { Reveal } from "../ui/Reveal";
import { SectionHeading } from "../ui/SectionHeading";
import { buttonStyles } from "../ui/buttonStyles";
const icons = {
  inmate: SearchIcon,
  calc: CalculatorIcon,
  pay: CreditCardIcon,
  forms: FileDownIcon
};
export function BondToolsSection() {
  return <section aria-labelledby="tools-title" className="section-y gutter bg-sand" data-id="element-139" data-mp="bdfatictv0cy">
      <div className="grid gap-[clamp(3rem,5vw,6rem)] xl:grid-cols-[0.85fr_1.15fr] 3xl:grid-cols-[0.7fr_1.3fr]" data-id="element-140" data-mp="3tis9f0n1s1nt">
        <div data-id="element-141" data-mp="1e6jkx9cjzua">
          <SectionHeading id="tools-title" eyebrow="Get your bail bond now" title={<>
                Start online, <em className="text-gold-hover" data-id="element-143" data-mp="2m68knzmuci5u">any hour.</em>
              </>} intro="Available 24/7 through our Bail Bond Agreement page. Find your loved one, calculate the cost, pay securely online, and download the forms you need — all in a few easy steps." data-id="element-142" data-mp="1hud3weskm90" />
          <Link to={routes.getBond} className={`${buttonStyles.navy} mt-10`} data-id="element-144" data-mp="3uzp5xl35ds8u">
            See all 5 steps
          </Link>
        </div>

        <ul className="grid gap-4 sm:grid-cols-2 3xl:grid-cols-4" data-id="element-145" data-mp="3qwk4zmyptymb">
          {bondTools.map((t, i) => {
          const Icon = icons[t.key];
          return <Reveal as="li" key={t.key} delay={i * 0.08} className="h-full" data-id="element-146" data-mp="3s4bve6569hq" data-mpi={i}>
                <Link to={t.to} className="group flex h-full min-h-[14rem] flex-col rounded-3xl border border-navy/10 bg-white p-7 shadow-soft transition-[transform,box-shadow,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-gold/50 hover:shadow-lift" data-id="element-147" data-mp="iijxuv6dtlgy">
                  <div className="flex items-start justify-between" data-id="element-148" data-mp="mkyfjbybef6n">
                    <span className="grid h-14 w-14 place-items-center rounded-2xl bg-navy" aria-hidden="true" data-id="element-149" data-mp="3gc565ffinagn">
                      <Icon className="h-6 w-6 text-gold-soft" strokeWidth={1.5} data-id="element-150" data-mp="3l9x00ezq16nh" />
                    </span>
                    <ArrowUpRightIcon className="h-5 w-5 text-navy/40 transition-[transform,color] duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-hover" aria-hidden="true" data-id="element-151" data-mp="3pb8ogh6uzlu3" />
                  </div>
                  <h3 className="mt-auto pt-10 font-serif text-2xl text-navy" data-id="element-152" data-mp="2z38927v1yze">{t.title}</h3>
                  <p className="mt-2 text-muted" data-id="element-153" data-mp="7xms8x2w90p4">{t.body}</p>
                </Link>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}